export default "__VITE_ASSET__fCly1KRj__"